// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na.direct-availability__calendar-link {\n  max-width: 140px;\n  border-color: #d0d3dc;\n  background-color: transparent;\n  color: #000;\n}\na.direct-availability__calendar-link:hover {\n  background-color: #f4f5f7;\n}\n", ""]);
// Exports
module.exports = exports;
